import Main from '@/views/common/main'
// 风控
export default [
    //'风控管理'
    {
        path: '/riskOperat',
        name: 'riskOperat',
        meta: {
            icon: 'ios-apps',
            title: '风控操作'
        },
        component: Main,
        children: [
            //玩家风控配置
            {
                path: 'userRiskConf',
                name: 'riskment_userRiskConf',
                meta: { title: '玩家风控配置' },
                component: () => import('@r/userRiskConf.vue')
            },
            {
                path: 'abnormalPlayerConf',
                name: 'riskment_abnormalPlayerConf',
                meta: { title: '异常玩家管理' },
                component: () => import('@r/AbnormalPlayerConf.vue')
            },
            // 游戏IP黑名单
            {
                path: 'userBlack',
                name: 'riskment_userBlack',
                meta: { title: '游戏IP黑名单' },
                component: () => import('@r/userBlack.vue')
            },

            // 平台报警数据监控
            {
                path: 'platWarn',
                name: 'riskment_platWarn',
                meta: { title: '平台报警数据监控' },
                component: () => import('@r/platWarn.vue')
            },
            {
                path: 'blackPhone',
                name: 'riskment_blackPhone',
                meta: { title: '手机号黑名单管理' },
                component: () => import('@r/blackPhone.vue')
            },
            {
                path: 'pvpInquire',
                name: 'riskment_pvpInquire',
                meta: { title: 'PVP伙牌查询' },
                component: () => import('@r/pvpInquire.vue')
            },
            {
                path: 'withBlack',
                name: 'riskment_withBlack',
                meta: { title: '提现黑名单管理' },
                component: () => import('@r/withBlack.vue')
            },
            {
                path: 'UserLimite',
                name: 'riskment_UserLimite',
                meta: { title: '提现用户限制管理' },
                component: () => import('@r/UserLimite.vue')
            },
            {
                path: 'userRiskInfo',
                name: 'riskment_userRiskInfo',
                meta: { title: '风控信息查询' },
                component: () => import('@r/UserRiskInfo.vue')
            },
            {
                path: 'abnormalCharacteristics',
                name: 'riskment_abnormalCharacteristics',
                meta: { title: '异常特征库' },
                component: () => import('@r/abnormalCharacteristics.vue')
            },
            {
                path: 'dataCenterRisk',
                name: 'riskment_dataCenterRisk',
                meta: { title: '玩家风控配置' },
                component: () => import('@r/dataCenterRisk.vue')
            }
        ]
    }
]
// 数据报表
